const images = [
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-41.jpg?v=1747926632",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-11.jpg?v=1747926632",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-46.jpg?v=1747926632",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-10.jpg?v=1747926632",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-44.jpg?v=1747926630",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Josii.jpg?v=1747926629",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-36.jpg?v=1747926629",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-59.jpg?v=1747926629",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-51.jpg?v=1747926629",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-7.jpg?v=1747926629",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Grey_Black_White_Logo_Pom_Hat_1.jpg?v=1747926627",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-30.jpg?v=1747926625",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Marketing.jpg?v=1747926623",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/11.15.18.miscellaneous-12.jpg?v=1747926623",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Blue_Pom_Hat_2.jpg?v=1747926621",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Womens_Long_Sleeve_White_-_front_2.jpg?v=1747926621",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4241.png?v=1747926620",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Boxercraft_Maroon-15.jpg?v=1747926613",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4285.png?v=1747926613",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Joggers.jpg?v=1747926613",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Carolina_Blue_Hoodie.jpg?v=1747926609",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/np-1-56_32025710218_o.jpg?v=1747926605",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Blue_Pom_Hat.jpg?v=1747926604",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/GroupShots-25.jpg?v=1747926602",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/GroupShots-25.jpg?v=1747926602",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/np-1-29_44983808515_o.jpg?v=1747926593",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/np-1-51_44983788545_o.jpg?v=1747926586",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4244.png?v=1747926586",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/np-1-43_44983795755_o.jpg?v=1747926585",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/np-1-5_44983830495_o_27db0d20-c44f-445f-ab0a-1ae340206eae.jpg?v=1747926576",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5390.jpg?v=1747926573",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5455.jpg?v=1747926570",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5455.jpg?v=1747926570",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5477.jpg?v=1747926570",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4242.png?v=1747926570",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5426.jpg?v=1747926570",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Reggie_home_screen.jpg?v=1747926564",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5512.jpg?v=1747926559",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4252.jpg?v=1747926557",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5011.jpg?v=1747926555",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4059.jpg?v=1747926554",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4212.jpg?v=1747926554",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5010.jpg?v=1747926553",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/White_Hoodie_899c0f1d-2a26-449b-b32e-a9e776075781.jpg?v=1747926547",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Mark_NP_Pic.jpg?v=1747926436",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/Max_Fishing_Never_Peak.jpg?v=1747926434",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5882.jpg?v=1747926433",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5890.jpg?v=1747926433",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5879.jpg?v=1747926433",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5875.jpg?v=1747926433",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5881.jpg?v=1747926432",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4216.jpg?v=1747926432",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5878.jpg?v=1747926432",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5889.jpg?v=1747926431",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5888.jpg?v=1747926429",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4326.png?v=1747926429",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4410.jpg?v=1747926428",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4879_88fc0c7e-55cd-46a3-8836-a42caf68f79d.jpg?v=1747926428",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_4324.png?v=1747926428",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_1423.jpg?v=1747908925",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_8048.png?v=1747908925",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_1704.jpg?v=1747908924",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_2963.jpg?v=1747908919",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_7975.jpg?v=1747908914",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_6813.jpg?v=1747908913",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_6825.jpg?v=1747908912",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_5563.jpg?v=1747908911",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/FE7CF901-14B3-49DC-9803-61D55E422B30.png?v=1747908911",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_0052.jpg?v=1747908907",
  "https://cdn.shopify.com/s/files/1/0705/1906/2696/files/IMG_7250.jpg?v=1747908905",
];

const shuffled = images.sort(() => 0.5 - Math.random());
const chunkSize = Math.ceil(shuffled.length / 3);
const rows = [
  shuffled.slice(0, chunkSize),
  shuffled.slice(chunkSize, 2 * chunkSize),
  shuffled.slice(2 * chunkSize),
];

const section = document.getElementById("community-scroll-section");
section.innerHTML = `
  <div style="padding: 60px 20px; background-color: #f9f9f9; font-family: Montserrat, sans-serif; text-align: center;">
    <h2 style="font-size: 32px; font-weight: bold; margin-bottom: 10px;">💪 The Never Peak Community</h2>
    <p style="font-size: 16px; color: #666; margin-bottom: 40px;">Our community is full of incredible people pushing their limits every day. Thank you for being part of the movement.</p>
    <div class="scroll-wrapper">
      <div class="scroll-row auto-scroll" id="row1"></div>
      <div class="scroll-row auto-scroll delay-1" id="row2"></div>
      <div class="scroll-row auto-scroll delay-2" id="row3"></div>
    </div>
    <p style="margin-top: 40px; font-size: 14px; color: #888;">Want to be featured? Tag us @NeverPeakProducts and use <strong>#NeverPeak</strong></p>
    <div class="lightbox" id="lightbox"><img id="lightbox-img" src=""></div>
  </div>
`;

rows.forEach((group, i) => {
  const row = document.getElementById(`row${i + 1}`);
  group.forEach((src) => {
    const img = document.createElement("img");
    img.src = src;
    img.alt = "Never Peak community image";
    img.addEventListener("click", () => {
      document.getElementById("lightbox-img").src = src;
      document.getElementById("lightbox").classList.add("show");
    });
    row.appendChild(img);
  });
});

// Add CSS styles via JavaScript safely
const styleTag = document.createElement("style");
styleTag.innerHTML = `
  .scroll-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }
  .scroll-row {
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding: 5px 0;
    cursor: grab;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
  }
  .scroll-row::-webkit-scrollbar {
    display: none;
  }
  .scroll-row img {
    height: 120px;
    border-radius: 10px;
    object-fit: cover;
    flex-shrink: 0;
    transition: transform 0.3s;
  }
  .scroll-row img:hover {
    transform: scale(1.1);
  }
  .scroll-row img:active {
    transform: scale(1.25);
  }
  .lightbox {
    display: none;
    position: fixed;
    z-index: 9999;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.85);
    justify-content: center;
    align-items: center;
  }
  .lightbox img {
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 15px;
  }
  .lightbox.show {
    display: flex;
  }
  .auto-scroll {
    animation: scroll-left 60s linear infinite;
  }
  .auto-scroll:hover {
    animation-play-state: paused;
  }
  .delay-1 { animation-delay: 5s; }
  .delay-2 { animation-delay: 10s; }

  @keyframes scroll-left {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
`;
document.head.appendChild(styleTag);

// Close lightbox on click
document.addEventListener("click", function (e) {
  if (e.target.id === "lightbox" || e.target.id === "lightbox-img") {
    document.getElementById("lightbox").classList.remove("show");
  }
});
